<template>
  <v-container class="no-margins">
    <div class="title-icon top">
      <h2>{{ selectedElement.name }}</h2>
      <v-icon small class="mt-n2 mr-n2" @click.prevent="$emit('close')">$sl-close</v-icon>
    </div>
    <v-toolbar class="bottomnav mt-n4" flat @click="$emit('changeClick', 'addElement')">
      <v-btn :aria-label="$t('ebook.element-change')" icon small>
        <v-icon>$sl-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="body-1 pl-0">{{
        $t("ebook.element-change")
      }}</v-toolbar-title>
    </v-toolbar>

    <v-divider class="mt-3 mb-5 fullwidth"></v-divider>

    <h5>{{ $t("ebook.elementpart") }}</h5>

    <template>
      <v-expand-transition v-if="selectedElement.bookSubElements">
        <v-card>
          <v-list one-line>
            <v-list-item-group>
              <template v-for="(item, index) in sortedSubElements">
                <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
                <v-list-item
                  :key="`emp-${index}`"
                  @click="
                    $emit('addElementClick', {
                      show: 'elementJudgement',
                      subElement: item,
                      elementName: selectedElement.name,
                    })
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>{{item.name}}</v-list-item-title>

                    <v-list-item-subtitle>
                      {{ 
                        $t('ebookReportElementsModal.achieved-level', { 
                          level1: item.maxInstructorSkillEstimatedLevel, 
                          level2: item.requiredLevel 
                        }) 
                      }}  
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action v-if="!item.isApproved">
                    <v-icon class>$sl-arrow-right</v-icon>
                  </v-list-item-action>

                  <v-icon v-else>$sl-completed</v-icon>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-expand-transition>
    </template>

    <template>
      <v-row class="mt-3">
        <v-col>
          <p class="mb-0 text-caption">{{ $t('ebookReportElementsModal.explanation-title') }}</p>
        </v-col>
      </v-row>

      <v-row class="d-flex flex-wrap align-center">
        <v-icon left right>$sl-completed</v-icon>
        <p class="mb-0 text-body-2 text-caption">{{ $t('ebookReportElementsModal.icon-explanation-text-2') }}</p>
      </v-row>

      <v-row>
        <v-col>
          <p class="mb-0 font-italic text-body-2">{{ $t('ebookReportElementsModal.report-limitation-text-2') }}</p>
        </v-col>
      </v-row>
    </template>
    
    <v-btn block class="mb-6 mt-10 btn-label application" @click.prevent="$emit('close')">
      <v-icon>$sl-cancel</v-icon>
      {{ $t("labels.cancel") }}
    </v-btn>
  </v-container>
</template>

<script>
import orderBy from 'lodash/orderBy'

// @group Company
// EbookElementModalAddSubElement component
export default {
  name: "EbookElementModalAddSubElement",
  props: {
    //selected element
    selectedElement: Object,
  },

  computed: {
    sortedSubElements() {
      return orderBy(this.selectedElement.bookSubElements, ['isApproved', 'DESC'])
    }
  }
};
</script>
